// Export an array of topics for VA 1st Grade Science
const va5thScienceQuizContent = [
// Forms of Energy - Multiple Choice
{
  "slug": "formsofenergy",
  "title": "Forms of Energy",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Where is chemical energy stored?",
      "questionImage": "",
      "answers": [
        { "text": "Bonds", "correct": true, "image": "" },
        { "text": "Wheels", "correct": false, "image": "" },
        { "text": "Clouds", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What stores mechanical energy?",
      "questionImage": "",
      "answers": [
        { "text": "Springs", "correct": true, "image": "" },
        { "text": "Paint", "correct": false, "image": "" },
        { "text": "Sand", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Where is nuclear energy stored?",
      "questionImage": "",
      "answers": [
        { "text": "Nucleus", "correct": true, "image": "" },
        { "text": "Orbit", "correct": false, "image": "" },
        { "text": "Crust", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What stores electrical energy?",
      "questionImage": "",
      "answers": [
        { "text": "Battery", "correct": true, "image": "" },
        { "text": "Leaf", "correct": false, "image": "" },
        { "text": "Brick", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Light, X-rays, radio waves are?",
      "questionImage": "",
      "answers": [
        { "text": "Radiant", "correct": true, "image": "" },
        { "text": "Solid", "correct": false, "image": "" },
        { "text": "Liquid", "correct": false, "image": "" }
      ]
    }
  ]
},
// Energy Transfer - Multiple Choice
{
  "slug": "energytransfer",
  "title": "Energy Transfer",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Solar panels change light to?",
      "questionImage": "",
      "answers": [
        { "text": "Electrical", "correct": true, "image": "" },
        { "text": "Sound", "correct": false, "image": "" },
        { "text": "Motion", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. A TV turns electrical into?",
      "questionImage": "",
      "answers": [
        { "text": "Light", "correct": true, "image": "" },
        { "text": "Fuel", "correct": false, "image": "" },
        { "text": "Friction", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Fuel in cars has what energy?",
      "questionImage": "",
      "answers": [
        { "text": "Chemical", "correct": true, "image": "" },
        { "text": "Magnetic", "correct": false, "image": "" },
        { "text": "Solar", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Batteries in flashlights change to?",
      "questionImage": "",
      "answers": [
        { "text": "Light", "correct": true, "image": "" },
        { "text": "Wind", "correct": false, "image": "" },
        { "text": "Tide", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Burning wood becomes?",
      "questionImage": "",
      "answers": [
        { "text": "Thermal", "correct": true, "image": "" },
        { "text": "Nuclear", "correct": false, "image": "" },
        { "text": "Electric", "correct": false, "image": "" }
      ]
    }
  ]
},
// Energy - Multiple Choice
{
  "slug": "energy",
  "title": "Energy",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Kinetic energy is?",
      "questionImage": "",
      "answers": [
        { "text": "In motion", "correct": true, "image": "" },
        { "text": "Stored up", "correct": false, "image": "" },
        { "text": "Silent", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Potential energy is?",
      "questionImage": "",
      "answers": [
        { "text": "Stored", "correct": true, "image": "" },
        { "text": "Moving", "correct": false, "image": "" },
        { "text": "Melting", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Heat, motion, sound, light are?",
      "questionImage": "",
      "answers": [
        { "text": "Forms", "correct": true, "image": "" },
        { "text": "Plants", "correct": false, "image": "" },
        { "text": "Minerals", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Electrical, thermal, chemical, nuclear are?",
      "questionImage": "",
      "answers": [
        { "text": "Energies", "correct": true, "image": "" },
        { "text": "Weathers", "correct": false, "image": "" },
        { "text": "Rocks", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Both groups fit into two?",
      "questionImage": "",
      "answers": [
        { "text": "Categories", "correct": true, "image": "" },
        { "text": "Colors", "correct": false, "image": "" },
        { "text": "Seasons", "correct": false, "image": "" }
      ]
    }
  ]
},
// Motion - Multiple Choice
{
  "slug": "motion",
  "title": "Motion",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What shows motion has happened?",
      "questionImage": "",
      "answers": [
        { "text": "Position change", "correct": true, "image": "" },
        { "text": "Same spot", "correct": false, "image": "" },
        { "text": "No time", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. A parked car moved 10 ft shows?",
      "questionImage": "",
      "answers": [
        { "text": "Motion", "correct": true, "image": "" },
        { "text": "Weather", "correct": false, "image": "" },
        { "text": "Friction", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Coasting on a highway is?",
      "questionImage": "",
      "answers": [
        { "text": "In motion", "correct": true, "image": "" },
        { "text": "At rest", "correct": false, "image": "" },
        { "text": "Melting", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Continuous position change means?",
      "questionImage": "",
      "answers": [
        { "text": "Motion", "correct": true, "image": "" },
        { "text": "Silence", "correct": false, "image": "" },
        { "text": "Erosion", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. A car parked at curb is?",
      "questionImage": "",
      "answers": [
        { "text": "Not moving", "correct": true, "image": "" },
        { "text": "Spinning", "correct": false, "image": "" },
        { "text": "Flying", "correct": false, "image": "" }
      ]
    }
  ]
},
// Friction - Multiple Choice
{
  "slug": "friction",
  "title": "Friction",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Friction is the ______ to motion.",
      "questionImage": "",
      "answers": [
        { "text": "Resistance", "correct": true, "image": "" },
        { "text": "Fuel", "correct": false, "image": "" },
        { "text": "Shadow", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Friction happens when objects?",
      "questionImage": "",
      "answers": [
        { "text": "Rub", "correct": true, "image": "" },
        { "text": "Freeze", "correct": false, "image": "" },
        { "text": "Float", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Friction makes?",
      "questionImage": "",
      "answers": [
        { "text": "Heat", "correct": true, "image": "" },
        { "text": "Light", "correct": false, "image": "" },
        { "text": "Snow", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Rubbing hands causes?",
      "questionImage": "",
      "answers": [
        { "text": "Friction", "correct": true, "image": "" },
        { "text": "Rust", "correct": false, "image": "" },
        { "text": "Steam", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Friction is made by objects moving?",
      "questionImage": "",
      "answers": [
        { "text": "Against", "correct": true, "image": "" },
        { "text": "Alone", "correct": false, "image": "" },
        { "text": "Apart", "correct": false, "image": "" }
      ]
    }
  ]
},
// Conductors - Drag and Drop
{
  "slug": "conductors",
  "title": "Conductors",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match material to type.",
      "options": [
        { "id": "copper", "text": "Copper", "image": "", "targetText": "Conductor", "targetImage": "" },
        { "id": "gold", "text": "Gold", "image": "", "targetText": "Conductor", "targetImage": "" },
        { "id": "rubber", "text": "Rubber", "image": "", "targetText": "Insulator", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match more examples.",
      "options": [
        { "id": "styro", "text": "Styrofoam", "image": "", "targetText": "Insulator", "targetImage": "" },
        { "id": "wire", "text": "Metal wire", "image": "", "targetText": "Conductor", "targetImage": "" },
        { "id": "glass", "text": "Glass", "image": "", "targetText": "Insulator", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match term to meaning.",
      "options": [
        { "id": "condef", "text": "Conductor", "image": "", "targetText": "Flows easily", "targetImage": "" },
        { "id": "insdef", "text": "Insulator", "image": "", "targetText": "Doesn’t flow", "targetImage": "" },
        { "id": "electron", "text": "Electrons", "image": "", "targetText": "Jumping", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match idea to effect.",
      "options": [
        { "id": "jump", "text": "Electron jump", "image": "", "targetText": "Current", "targetImage": "" },
        { "id": "block", "text": "No jumping", "image": "", "targetText": "No current", "targetImage": "" },
        { "id": "flow", "text": "Easy flow", "image": "", "targetText": "Conduct", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match item to category.",
      "options": [
        { "id": "coin", "text": "Copper coin", "image": "", "targetText": "Conductor", "targetImage": "" },
        { "id": "eraser", "text": "Rubber band", "image": "", "targetText": "Insulator", "targetImage": "" },
        { "id": "foil", "text": "Gold foil", "image": "", "targetText": "Conductor", "targetImage": "" }
      ]
    }
  ]
},
// Circuits - Multiple Choice
{
  "slug": "circuits",
  "title": "Circuits",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. A circuit is?",
      "questionImage": "",
      "answers": [
        { "text": "Path electricity takes", "correct": true, "image": "" },
        { "text": "Path water takes", "correct": false, "image": "" },
        { "text": "Path wind takes", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Electricity flows through?",
      "questionImage": "",
      "answers": [
        { "text": "Closed circuit", "correct": true, "image": "" },
        { "text": "Open circuit", "correct": false, "image": "" },
        { "text": "Broken path", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Series circuits have?",
      "questionImage": "",
      "answers": [
        { "text": "One path", "correct": true, "image": "" },
        { "text": "No path", "correct": false, "image": "" },
        { "text": "Many paths", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Parallel circuits have?",
      "questionImage": "",
      "answers": [
        { "text": "More than one path", "correct": true, "image": "" },
        { "text": "Only one path", "correct": false, "image": "" },
        { "text": "Closed loop only", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Electricity cannot flow through?",
      "questionImage": "",
      "answers": [
        { "text": "Open circuit", "correct": true, "image": "" },
        { "text": "Closed circuit", "correct": false, "image": "" },
        { "text": "Parallel circuit", "correct": false, "image": "" }
      ]
    }
  ]
},
// Sound Vibration - Multiple Choice
{
  "slug": "soundvibration",
  "title": "Sound Vibration",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Sound comes from?",
      "questionImage": "",
      "answers": [
        { "text": "Vibration", "correct": true, "image": "" },
        { "text": "Reflection", "correct": false, "image": "" },
        { "text": "Refraction", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Plucking a guitar string shows?",
      "questionImage": "",
      "answers": [
        { "text": "Vibration makes sound", "correct": true, "image": "" },
        { "text": "Light bends", "correct": false, "image": "" },
        { "text": "Heat forms", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Your vocal cords produce sound by?",
      "questionImage": "",
      "answers": [
        { "text": "Vibrating", "correct": true, "image": "" },
        { "text": "Cooling", "correct": false, "image": "" },
        { "text": "Stretching", "correct": false, "image": "" }
      ]
    }
  ]
},
// Traveling Sound - Multiple Choice
{
  "slug": "travelingsound",
  "title": "Traveling Sound",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Sound travels fastest in?",
      "questionImage": "",
      "answers": [
        { "text": "Solids", "correct": true, "image": "" },
        { "text": "Liquids", "correct": false, "image": "" },
        { "text": "Gases", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Sound travels slowest in?",
      "questionImage": "",
      "answers": [
        { "text": "Gases", "correct": true, "image": "" },
        { "text": "Solids", "correct": false, "image": "" },
        { "text": "Liquids", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Molecules in solids are?",
      "questionImage": "",
      "answers": [
        { "text": "Close together", "correct": true, "image": "" },
        { "text": "Far apart", "correct": false, "image": "" },
        { "text": "Always moving fast", "correct": false, "image": "" }
      ]
    }
  ]
},
// Wave Properties - Multiple Choice
{
  "slug": "waveproperties",
  "title": "Wave Properties",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Frequency is?",
      "questionImage": "",
      "answers": [
        { "text": "Waves per second", "correct": true, "image": "" },
        { "text": "Wave height", "correct": false, "image": "" },
        { "text": "Wave bend", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Wavelength is?",
      "questionImage": "",
      "answers": [
        { "text": "Distance crest to crest", "correct": true, "image": "" },
        { "text": "Time for one wave", "correct": false, "image": "" },
        { "text": "Height of wave", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Amplitude is?",
      "questionImage": "",
      "answers": [
        { "text": "Wave height", "correct": true, "image": "" },
        { "text": "Waves per second", "correct": false, "image": "" },
        { "text": "Bending light", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Period is?",
      "questionImage": "",
      "answers": [
        { "text": "Time for one wave", "correct": true, "image": "" },
        { "text": "Energy size", "correct": false, "image": "" },
        { "text": "Wave speed", "correct": false, "image": "" }
      ]
    }
  ]
},
// Compression - Drag and Drop
{
  "slug": "compression",
  "title": "Compression",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match wave type to description.",
      "options": [
        { "id": "long", "text": "Compression", "image": "", "targetText": "Longitudinal", "targetImage": "" },
        { "id": "side", "text": "Moves back/forward", "image": "", "targetText": "Direction of travel", "targetImage": "" },
        { "id": "sound", "text": "Sound wave", "image": "", "targetText": "Compression wave", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match medium to fact.",
      "options": [
        { "id": "solid", "text": "Solid", "image": "", "targetText": "Carries sound", "targetImage": "" },
        { "id": "liquid", "text": "Liquid", "image": "", "targetText": "Carries sound", "targetImage": "" },
        { "id": "gas", "text": "Gas", "image": "", "targetText": "Carries sound", "targetImage": "" }
      ]
    }
  ]
},
// Reflection - Multiple Choice
{
  "slug": "reflection",
  "title": "Reflection",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Reflection happens when light?",
      "questionImage": "",
      "answers": [
        { "text": "Bounces", "correct": true, "image": "" },
        { "text": "Bends", "correct": false, "image": "" },
        { "text": "Stops", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Smooth surfaces cause?",
      "questionImage": "",
      "answers": [
        { "text": "More reflection", "correct": true, "image": "" },
        { "text": "Less light", "correct": false, "image": "" },
        { "text": "No light", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Rough surfaces cause?",
      "questionImage": "",
      "answers": [
        { "text": "Scattering", "correct": true, "image": "" },
        { "text": "Clear mirror", "correct": false, "image": "" },
        { "text": "Absorption", "correct": false, "image": "" }
      ]
    }
  ]
},
// Refraction - Multiple Choice
{
  "slug": "refraction",
  "title": "Refraction",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Refraction is when light?",
      "questionImage": "",
      "answers": [
        { "text": "Bends", "correct": true, "image": "" },
        { "text": "Bounces", "correct": false, "image": "" },
        { "text": "Stops", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Light bends when moving from air to?",
      "questionImage": "",
      "answers": [
        { "text": "Water", "correct": true, "image": "" },
        { "text": "Sky", "correct": false, "image": "" },
        { "text": "Mirror", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Light speeds up when returning to?",
      "questionImage": "",
      "answers": [
        { "text": "Air", "correct": true, "image": "" },
        { "text": "Metal", "correct": false, "image": "" },
        { "text": "Soil", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "transverse",
  "title": "Transverse",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. In a transverse wave, what does the wavelength show?",
      "questionImage": "",
      "answers": [
        { "text": "Distance crest-to-crest", "correct": true, "image": "" },
        { "text": "Height of a crest", "correct": false, "image": "" },
        { "text": "Loudness of sound", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What do we call the highest point of the wave?",
      "questionImage": "",
      "answers": [
        { "text": "Crest", "correct": true, "image": "" },
        { "text": "Trough", "correct": false, "image": "" },
        { "text": "Middle", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What do we call the lowest point of the wave?",
      "questionImage": "",
      "answers": [
        { "text": "Trough", "correct": true, "image": "" },
        { "text": "Crest", "correct": false, "image": "" },
        { "text": "Peak", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Wavelength is measured in which unit?",
      "questionImage": "",
      "answers": [
        { "text": "Meters", "correct": true, "image": "" },
        { "text": "Seconds", "correct": false, "image": "" },
        { "text": "Degrees", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which three parts are named in the song?",
      "questionImage": "",
      "answers": [
        { "text": "Wavelength, crest, trough", "correct": true, "image": "" },
        { "text": "Speed, mass, time", "correct": false, "image": "" },
        { "text": "Push, pull, twist", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "matter",
  "title": "Matter",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What do all kinds of matter have?",
      "questionImage": "",
      "answers": [
        { "text": "Mass & volume", "correct": true, "image": "" },
        { "text": "Only color", "correct": false, "image": "" },
        { "text": "Just a smell", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which is NOT a state of matter?",
      "questionImage": "",
      "answers": [
        { "text": "Light", "correct": false, "image": "" },
        { "text": "Solid", "correct": false, "image": "" },
        { "text": "Liquid", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. How do particles in a solid mostly move?",
      "questionImage": "",
      "answers": [
        { "text": "Vibrate in place", "correct": true, "image": "" },
        { "text": "Zoom far apart", "correct": false, "image": "" },
        { "text": "Stand perfectly still", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What do liquids do in a container?",
      "questionImage": "",
      "answers": [
        { "text": "Take the container’s shape", "correct": true, "image": "" },
        { "text": "Keep their own shape", "correct": false, "image": "" },
        { "text": "Float into space", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which is true about gases?",
      "questionImage": "",
      "answers": [
        { "text": "Spread out and move fast", "correct": true, "image": "" },
        { "text": "Always stay tightly packed", "correct": false, "image": "" },
        { "text": "Never change volume", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "3statesofmatter",
  "title": "3 States of Matter",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Matter is made of tiny pieces called…",
      "questionImage": "",
      "answers": [
        { "text": "Atoms & molecules", "correct": true, "image": "" },
        { "text": "Pebbles & sand", "correct": false, "image": "" },
        { "text": "Beams of light", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which group lists the three states?",
      "questionImage": "",
      "answers": [
        { "text": "Solids, liquids, gases", "correct": true, "image": "" },
        { "text": "Clouds, rainbows, fog", "correct": false, "image": "" },
        { "text": "Sun, moon, stars", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which state is most like water in a cup?",
      "questionImage": "",
      "answers": [
        { "text": "Liquid", "correct": true, "image": "" },
        { "text": "Solid", "correct": false, "image": "" },
        { "text": "Gas", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. The air around Earth is mostly a…",
      "questionImage": "",
      "answers": [
        { "text": "Gas", "correct": true, "image": "" },
        { "text": "Solid", "correct": false, "image": "" },
        { "text": "Liquid", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which state usually keeps its own shape?",
      "questionImage": "",
      "answers": [
        { "text": "Solid", "correct": true, "image": "" },
        { "text": "Liquid", "correct": false, "image": "" },
        { "text": "Gas", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "atoms",
  "title": "Atoms",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What are atoms?",
      "questionImage": "",
      "answers": [
        { "text": "Smallest particles of matter", "correct": true, "image": "" },
        { "text": "Biggest rocks on Earth", "correct": false, "image": "" },
        { "text": "Drops of water", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which particles live in the nucleus?",
      "questionImage": "",
      "answers": [
        { "text": "Protons & neutrons", "correct": true, "image": "" },
        { "text": "Electrons only", "correct": false, "image": "" },
        { "text": "Photons & shadows", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What charge does a proton have?",
      "questionImage": "",
      "answers": [
        { "text": "Positive", "correct": true, "image": "" },
        { "text": "Negative", "correct": false, "image": "" },
        { "text": "No charge", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which particle has no charge?",
      "questionImage": "",
      "answers": [
        { "text": "Neutron", "correct": true, "image": "" },
        { "text": "Proton", "correct": false, "image": "" },
        { "text": "Electron", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Where do electrons move?",
      "questionImage": "",
      "answers": [
        { "text": "Around the nucleus", "correct": true, "image": "" },
        { "text": "Inside the core", "correct": false, "image": "" },
        { "text": "Far outside the atom", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "plateboundaries",
  "title": "Plate Boundaries",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. When plates move together, the boundary is called…",
      "questionImage": "",
      "answers": [
        { "text": "Convergent", "correct": true, "image": "" },
        { "text": "Divergent", "correct": false, "image": "" },
        { "text": "Transform", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. When plates move apart, the boundary is called…",
      "questionImage": "",
      "answers": [
        { "text": "Divergent", "correct": true, "image": "" },
        { "text": "Convergent", "correct": false, "image": "" },
        { "text": "Stationary", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. When plates slide past each other, the boundary is…",
      "questionImage": "",
      "answers": [
        { "text": "Transform", "correct": true, "image": "" },
        { "text": "Divergent", "correct": false, "image": "" },
        { "text": "Circular", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What often happens at plate boundaries?",
      "questionImage": "",
      "answers": [
        { "text": "Earthquakes & volcanoes", "correct": true, "image": "" },
        { "text": "Rainbows & fog", "correct": false, "image": "" },
        { "text": "Tides & waves only", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Moving apart plates can form undersea…",
      "questionImage": "",
      "answers": [
        { "text": "Mountains/ridges", "correct": true, "image": "" },
        { "text": "Caves in the sky", "correct": false, "image": "" },
        { "text": "Islands of ice cream", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "mythreerocks",
  "title": "My Three Rocks",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Which rock forms in layers, often near water?",
      "questionImage": "",
      "answers": [
        { "text": "Sedimentary", "correct": true, "image": "" },
        { "text": "Igneous", "correct": false, "image": "" },
        { "text": "Metamorphic", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which rock forms when lava cools and hardens?",
      "questionImage": "",
      "answers": [
        { "text": "Igneous", "correct": true, "image": "" },
        { "text": "Sedimentary", "correct": false, "image": "" },
        { "text": "Metamorphic", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Heat and pressure change other rocks into what?",
      "questionImage": "",
      "answers": [
        { "text": "Metamorphic", "correct": true, "image": "" },
        { "text": "Sand", "correct": false, "image": "" },
        { "text": "Soil", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which rock type can have fossils?",
      "questionImage": "",
      "answers": [
        { "text": "Sedimentary", "correct": true, "image": "" },
        { "text": "Igneous", "correct": false, "image": "" },
        { "text": "Metamorphic", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which list names the three main rock types?",
      "questionImage": "",
      "answers": [
        { "text": "Sed., ign., meta.", "correct": true, "image": "" },
        { "text": "Clay, silt, sand", "correct": false, "image": "" },
        { "text": "Coal, steel, glass", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "rockcycle",
  "title": "Rock Cycle",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Cooling magma makes which rock?",
      "questionImage": "",
      "answers": [
        { "text": "Igneous", "correct": true, "image": "" },
        { "text": "Sedimentary", "correct": false, "image": "" },
        { "text": "Metamorphic", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Bits of rock pressed in layers form what?",
      "questionImage": "",
      "answers": [
        { "text": "Sedimentary", "correct": true, "image": "" },
        { "text": "Igneous", "correct": false, "image": "" },
        { "text": "Metal", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Heat and pressure deep underground form which rock?",
      "questionImage": "",
      "answers": [
        { "text": "Metamorphic", "correct": true, "image": "" },
        { "text": "Clay", "correct": false, "image": "" },
        { "text": "Igneous", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What does the rock cycle show?",
      "questionImage": "",
      "answers": [
        { "text": "Rocks keep changing", "correct": true, "image": "" },
        { "text": "Rocks never change", "correct": false, "image": "" },
        { "text": "Only one rock exists", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. When magma cools slowly, what forms inside the rock?",
      "questionImage": "",
      "answers": [
        { "text": "Crystals", "correct": true, "image": "" },
        { "text": "Fossils", "correct": false, "image": "" },
        { "text": "Clouds", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "surfacechange",
  "title": "Surface Change",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Weathering mostly means rocks are…",
      "questionImage": "",
      "answers": [
        { "text": "Broken apart", "correct": true, "image": "" },
        { "text": "Painted new", "correct": false, "image": "" },
        { "text": "Glued together", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Erosion mostly means pieces are…",
      "questionImage": "",
      "answers": [
        { "text": "Moved away", "correct": true, "image": "" },
        { "text": "Heated up", "correct": false, "image": "" },
        { "text": "Frozen solid", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. A canyon usually forms because a river…",
      "questionImage": "",
      "answers": [
        { "text": "Erodes rock", "correct": true, "image": "" },
        { "text": "Paints rock", "correct": false, "image": "" },
        { "text": "Floats rock up", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which event can quickly change Earth’s surface?",
      "questionImage": "",
      "answers": [
        { "text": "Earthquake", "correct": true, "image": "" },
        { "text": "Sunrise", "correct": false, "image": "" },
        { "text": "Rainbow", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. In chemical weathering, water can…",
      "questionImage": "",
      "answers": [
        { "text": "Dissolve minerals", "correct": true, "image": "" },
        { "text": "Make fossils", "correct": false, "image": "" },
        { "text": "Stop erosion", "correct": false, "image": "" }
      ]
    }
  ]
},

{
  "slug": "weathering",
  "title": "Weathering",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Weathering does what to rocks?",
      "questionImage": "",
      "answers": [
        { "text": "Breaks them down", "correct": true, "image": "" },
        { "text": "Builds them up", "correct": false, "image": "" },
        { "text": "Paints them red", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Erosion does what to broken pieces?",
      "questionImage": "",
      "answers": [
        { "text": "Moves them", "correct": true, "image": "" },
        { "text": "Heats them", "correct": false, "image": "" },
        { "text": "Freezes them", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Deposition is when pieces are…",
      "questionImage": "",
      "answers": [
        { "text": "Dropped in a new place", "correct": true, "image": "" },
        { "text": "Made from magma", "correct": false, "image": "" },
        { "text": "Melted into lava", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which things often cause weathering and erosion?",
      "questionImage": "",
      "answers": [
        { "text": "Wind & water", "correct": true, "image": "" },
        { "text": "Music & art", "correct": false, "image": "" },
        { "text": "Light & shadow", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Changes to Earth’s surface usually happen…",
      "questionImage": "",
      "answers": [
        { "text": "Over time", "correct": true, "image": "" },
        { "text": "All at once", "correct": false, "image": "" },
        { "text": "Never ever", "correct": false, "image": "" }
      ]
    }
  ]
},

{
  "slug": "naturalresources",
  "title": "Natural Resources",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Which resources can be replaced by nature in a short time?",
      "questionImage": "",
      "answers": [
        { "text": "Renewable", "correct": true, "image": "" },
        { "text": "Nonrenewable", "correct": false, "image": "" },
        { "text": "Inexhaustible", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Trees, fish, and horses are examples of which type?",
      "questionImage": "",
      "answers": [
        { "text": "Renewable", "correct": true, "image": "" },
        { "text": "Nonrenewable", "correct": false, "image": "" },
        { "text": "Recyclable", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Oil, gas, and coal are called what?",
      "questionImage": "",
      "answers": [
        { "text": "Nonrenewable", "correct": true, "image": "" },
        { "text": "Renewable", "correct": false, "image": "" },
        { "text": "Inexhaustible", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which resource will not run out during our lifetime?",
      "questionImage": "",
      "answers": [
        { "text": "Sunlight", "correct": true, "image": "" },
        { "text": "Coal", "correct": false, "image": "" },
        { "text": "Gasoline", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Copper, tin, and aluminum are examples of what kind of resource?",
      "questionImage": "",
      "answers": [
        { "text": "Recyclable", "correct": true, "image": "" },
        { "text": "Nonrenewable", "correct": false, "image": "" },
        { "text": "Inexhaustible", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "fossilfuels",
  "title": "Fossil Fuels",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What are coal, oil, and natural gas made from over long time?",
      "questionImage": "",
      "answers": [
        { "text": "Old plants/animals", "correct": true, "image": "" },
        { "text": "Fresh rainwater", "correct": false, "image": "" },
        { "text": "New plastic", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. How long did fossil fuels take to form?",
      "questionImage": "",
      "answers": [
        { "text": "Millions of years", "correct": true, "image": "" },
        { "text": "One day", "correct": false, "image": "" },
        { "text": "One week", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why are fossil fuels nonrenewable?",
      "questionImage": "",
      "answers": [
        { "text": "They form very slowly", "correct": true, "image": "" },
        { "text": "They are sunlight", "correct": false, "image": "" },
        { "text": "They are recycled daily", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which list shows only fossil fuels?",
      "questionImage": "",
      "answers": [
        { "text": "Coal, oil, gas", "correct": true, "image": "" },
        { "text": "Sun, wind, rain", "correct": false, "image": "" },
        { "text": "Copper, tin, gold", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What do people mainly use fossil fuels for?",
      "questionImage": "",
      "answers": [
        { "text": "Energy", "correct": true, "image": "" },
        { "text": "Art", "correct": false, "image": "" },
        { "text": "Snacks", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "conservewater",
  "title": "Conserve Water",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. When should you turn the water off while washing hands?",
      "questionImage": "",
      "answers": [
        { "text": "While scrubbing", "correct": true, "image": "" },
        { "text": "All the time", "correct": false, "image": "" },
        { "text": "Never ever", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What should you do after wetting your hands?",
      "questionImage": "",
      "answers": [
        { "text": "Add soap, turn off", "correct": true, "image": "" },
        { "text": "Add soap, leave on", "correct": false, "image": "" },
        { "text": "Skip soap", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. When brushing teeth, how do you save water?",
      "questionImage": "",
      "answers": [
        { "text": "Turn off while brushing", "correct": true, "image": "" },
        { "text": "Run water the whole time", "correct": false, "image": "" },
        { "text": "Use extra water for fun", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. When should you turn the water back on?",
      "questionImage": "",
      "answers": [
        { "text": "To rinse", "correct": true, "image": "" },
        { "text": "To sing", "correct": false, "image": "" },
        { "text": "To look at it", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why do we conserve water?",
      "questionImage": "",
      "answers": [
        { "text": "Protect resources", "correct": true, "image": "" },
        { "text": "Make bigger bills", "correct": false, "image": "" },
        { "text": "Waste on purpose", "correct": false, "image": "" }
      ]
    }
  ]
},


]

export default va5thScienceQuizContent;
